import React, { useRef, useEffect, useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"
import { appTools, cn } from "lib/utils"

interface ISelectField {
  options?:{ value:string, label:string }[]
  children?:React.ReactNode
  className?:string
  [key:string]:any
}

// function SelectOption({ label, value, ...rest }:{ label:string, value:string; [key:string]:any }){ 
//   return (
//     <div 
//       className="w-full h-8 flex justify-start items-center hover:bg-slate-800 px-2 cursor-pointer text-sm text-gray-200"
//       {...rest}
//     >
//       {label}
//     </div>
//   )
// }


export default function Select({ 
  options,
  children, 
  className, 
  ...rest
}:ISelectField){

  return (
    <div className="w-full relative">
      <select 
        className={cn(
          "w-full h-8 bg-slate-900 border border-solid border-slate-700 outline-transparent outline outline-offset-2 focus:outline-none rounded-md px-2", className
        )} 
        {...rest}
      >
        { options && options.map( (option:any) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}

        { !options && children }
      </select>
    </div>
  )
}